import axios from '../../axios/axiosconf';
//import axios from "axios";
//import { baseUrl, baseUrlCSRFCookie } from "../../../resources/Constants";
import React, { useState } from "react";
import { Link, Redirect, useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import { useEffect } from 'react';

// Instancia axios para hacer solicitud del CSRF Cookie al backend (Ver documentación de Laravel. Solo se hace una vez, cuando el usuario se loggea: https://laravel.com/docs/9.x/sanctum#spa-authentication)
/*const axiosInstanceCSRFCookie = axios.create({
    baseURL: baseUrlCSRFCookie,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
});

// Instancia axios para autenticación
const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
});*/

function ActivateUser() {

    const queryParams = new URLSearchParams(window.location.search);

    const search = useLocation().search;
    //const id = new URLSearchParams(search).get('uid');

    const [email, setEmail] = useState(queryParams.get('email'));
    const [uid, setUid] = useState(new URLSearchParams(search).get('uid'));
    const [userStatus, setUserStatus] = useState('...');
    let history = useHistory();

    useEffect(() => {

        /*axiosInstanceCSRFCookie.get('/sanctum/csrf-cookie')
            .then(response => {*/
                axios.get('/activate-user?uid='+uid)
                    .then(response => {
                        console.log(response);
                        if (response.status===200) {

                            setUserStatus(response.data.user_status_message);

                            if (response.data.user_status=='0') {
                                localStorage.setItem('userdata',JSON.stringify(response.data));
                                
                                history.push('/setup-cuenta');
                            }
                            else if (response.data.user_status=='1') {
                                history.push('/');
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error.response);
                    });
            /*})
            .catch(error => console.log(error));*/

    },[uid]);
    
    //return null;

    return <div>{userStatus}</div>;
}

export default ActivateUser;